import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { useState, useEffect } from "react";

const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export default function LangSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === i18n.language?.slice(0, 2)) || LANGS[0];

  useEffect(() => {
    const close = (e) => { if (!e.target.closest("[data-langsw]")) setOpen(false); };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <div className="relative" data-langsw data-testid="lang-switcher">
      <button onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/[0.04] border border-white/10 hover:bg-white/[0.08] text-xs"
        data-testid="lang-switcher-btn"
        title={current.label}>
        <span className="text-base leading-none">{current.flag}</span>
        {!compact && <span className="font-bold uppercase text-[10px]">{current.code}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-[#0d0d10] border border-white/10 rounded-xl shadow-xl py-1 min-w-[150px] z-50">
          {LANGS.map((l) => (
            <button key={l.code}
              onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
              data-testid={`lang-opt-${l.code}`}
              className={`w-full flex items-center gap-3 px-3 py-2 text-xs hover:bg-white/[0.04] ${l.code === current.code ? "text-[#ff0033] font-bold" : "text-white/70"}`}>
              <span className="text-base leading-none">{l.flag}</span>
              <span>{l.label}</span>
              {l.code === current.code && <span className="ml-auto">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
